import axios from '@/plugins/axios.js'

export function getUserMenu(parentId){
    return axios.get("/system/user/menu?parentId="+parentId||'')
}